import { TGameSliceState } from "../redux/bubblesSlice";

export function getUpdatedCircleDisabledStatuses(state: TGameSliceState) {
	Object.values(state.circles).forEach((c) => (c.isDisabled = false));
	Object.values(state.circles).forEach((c) => (c.touches ? (state.circles[c.touches].isDisabled = true) : {}));

	return state.circles;
}
